import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import Button from "@mmfestival/shared-components/common/Button";

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : "");

if (!API_BASE) {
  throw new Error("VITE_API_BASE_URL is missing");
}

export const Sukses = () => {
  const [searchParams] = useSearchParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const orderId = searchParams.get("order_id");
  const status = searchParams.get("transaction_status");

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        if (orderId) {
          const res = await axios.get(
            `${API_BASE}/api/payment/status/${orderId}`
          );
          if (res.data) {
            setTransaction(res.data);
          } else {
            console.error("Transaction data not found.");
          }
        }
      } catch (error) {
        console.error("Failed to fetch transaction data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchTransaction();
    }

    if (status === "settlement") {
      setMessage("Payment successful!");
    } else if (status === "pending") {
      setMessage(
        "Your payment is being processed. Please wait for confirmation."
      );
    } else if (status === "failed") {
      setMessage("Payment failed. Please try again.");
    }
  }, [orderId, status]);

  return (
    <section
      id="sukses-section"
      className="w-full min-h-screen flex justify-center items-center relative bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.pexels.com/photos/325185/pexels-photo-325185.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-slate-900 bg-opacity-40 backdrop-blur-sm"></div>

      <div className="relative z-10 flex flex-col items-center text-white w-full px-4 md:px-8">
        <fieldset className="fieldset w-full sm:w-96 bg-white bg-opacity-40 p-6 rounded-xl shadow-lg backdrop-blur-md">
          <p className="text-2xl font-semibold mb-4 text-center">Payment</p>

          {loading ? (
            <p className="text-center">Fetching transaction data...</p>
          ) : transaction ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <p className="mb-2 text-center">
                Order ID: {transaction.order_id}
              </p>
              <p className="mb-2 text-center">
                Status: {transaction.transaction_status}
              </p>
              <p className="mb-2 text-center">
                Total: Rp {Number(transaction.gross_amount).toLocaleString()}
              </p>

              <Button onClick={() => navigate("/")}>Back to Home</Button>
            </motion.div>
          ) : (
            <p className="text-red-500 text-center">
              Transaction data not found.
            </p>
          )}

          <p className="text-center mt-4">{message}</p>
        </fieldset>
      </div>
    </section>
  );
};
